import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import FilterCategoryPrice from "../components/FilterCategoryPrice";
import avatar from "../assets/images/avatar.png";
import woman from "../pages/Images/woman.png";
import blouse from "../pages/Images/blouse.png";
import { Link } from "react-router-dom";
import MoreItems from "../components/MoreItems";
import { useAuth } from "../context/AuthContext";
import LoginPrompt from "../components/LoginPrompt";

export default function SingleProductPage() {
  const history = useHistory();
  const { user } = useAuth();

  const images = [woman, blouse];
  const [selectedImgIdx, setSelectedImgIdx] = useState(0);
const [showPrompt, setShowPrompt] = useState(false)
  const handleAddToCart = () => {
    if(Object.keys(user).length ){
      history.push('/cart')
    }else {
      setShowPrompt(true)
    }
  }
  return (
    <div className="min-h-screen mt-32 md:mt-48 py-8 px-4 md:px-32 bg-gray4">
      <LoginPrompt openAuthModal={showPrompt} closeAuthModal={setShowPrompt}/>
      <FilterCategoryPrice />
      <div className="flex flex-wrap bg-white my-12 md:divide-x divide-gray1">
        <div className="w-full md:w-6/12">
          <div className="flex justify-center items-center p-6 h-96 overflow-hidden">
            <img
              src={images[selectedImgIdx]}
              alt=" danshiki shirt"
              className="w-4/12 mb-6 "
            />
          </div>

          <div className="flex justify-center">
            {images.map((item, idx) => (
              <div
                className={`p-4 flex items-center  cursor-pointer  hover:shadow-xl transition duration-500 ease-in-out rounded-md  mx-8 ${
                  selectedImgIdx === idx ? "border border-primary" : ""
                }`}
                onClick={() => setSelectedImgIdx(idx)}
              >
                <img src={item} alt="danshiki shirt" className=" w-20" />
              </div>
            ))}
          </div>
        </div>
        <div className="w-full md:w-6/12">
          <div className="py-8 px-4">
            <h2 className="font-medium text-2xl">Ankara Material</h2>
            <p className="font-light text-sm my-6 leading-loose text-gray1">
              Great Quality Ankara with eye catching design patterns. Fabric
              made with pure cotton, detailed colour combination and patterns.
              Suitable for all kinds of styles and occasions. Unique African
              print made by Africans with the finest cutton.
            </p>
          </div>

          <div className="flex justify-between border-b border-t border-gray1 p-4">
            <div>
              <h4 className="font-semibold text-xl mb-2">₦3,000</h4>
              <p className="font-semibold text-lg line-through text-gray1 mb-2">
                30,000
              </p>
              <p className="text-green font-semibold text-sm">Savings: 5,000</p>
            </div>

            <div className="flex">
              {[1, 2, 3, 4, 5].map((item) => (
                <svg
                  key={item}
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 4L17.09 10.26L24 11.27L19 16.14L20.18 23.02L14 19.77L7.82 23.02L9 16.14L4 11.27L10.91 10.26L14 4Z"
                    fill="#FA9A2A"
                  />
                </svg>
              ))}
            </div>
          </div>

          <div className="p-4">
            <p className="mb-6 font-medium">AVAILABLE VARIATIONS</p>
            <span className="border border-primary bg-primary bg-opacity-20 text-primary text-sm px-4 py-2 rounded-sm font-semibold">
              2 Yards
            </span>
          </div>

          <div className="flex justify-center items-center py-8">
            <button className="bg-primary text-white w-6/12 py-3 rounded-md" onClick={handleAddToCart}>
              Add To Cart
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap md:divide-x divide-gray1 bg-white">
        <div className="w-full md:w-6/12">
          <h2 className="border-b boder-gray1 p-4 text-xl font-medium">
            SPECIFICATIONS
          </h2>
          <div className="p-4">
            <ul className="list-disc p-4 font-medium">
              <li className="my-2">100% Nigerian</li>
              <li className="my-2">Great Quality</li>
              <li className="my-2">Lorem Ipsium</li>
            </ul>

            <div className="flex text-gray1 items-center">
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 18V5H3V18H18ZM18 18H25V13L22 10H18V18ZM10 20.5C10 21.8807 8.88071 23 7.5 23C6.11929 23 5 21.8807 5 20.5C5 19.1193 6.11929 18 7.5 18C8.88071 18 10 19.1193 10 20.5ZM23 20.5C23 21.8807 21.8807 23 20.5 23C19.1193 23 18 21.8807 18 20.5C18 19.1193 19.1193 18 20.5 18C21.8807 18 23 19.1193 23 20.5Z"
                  stroke="#A69597"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p className="ml-2">SHIPPED TO ANY DESTINATION</p>
            </div>
          </div>
        </div>
        <div className="md:w-6/12">
          <h2 className="border-b boder-gray1 p-4 text-xl font-medium">
            VENDORS DETAILS
          </h2>

          <div className="p-6 flex flex-wrap justify-between items-start">
            <div className="w-full md:w-auto flex items-start">
              <img src={avatar} alt="avatar" className="w-16 h-16" />
              <div className="ml-4">
                <h4 className="mb-4 text-lg font-medium">Amaka Fabriks</h4>
                <span className="bg-green border border-green rounded-full px-8 py-1 bg-opacity-20 text-green text-sm">
                  Vendor
                </span>
                <div className="flex my-4">
                  {[1, 2, 3, 4, 5].map((item) => (
                    <svg
                      key={item}
                      className="w-6 h-6"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 4L17.09 10.26L24 11.27L19 16.14L20.18 23.02L14 19.77L7.82 23.02L9 16.14L4 11.27L10.91 10.26L14 4Z"
                        fill="#FA9A2A"
                      />
                    </svg>
                  ))}
                </div>
              </div>
            </div>
            <div className="w-4/12">
              <Link to="/products/vendor/1">
                <button className="bg-primary w-full text-white py-3 rounded-md">
                  VIEW VENDOR
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <MoreItems />
    </div>
  );
}
